import type { ApplicationForm } from './form.types'

const form: ApplicationForm = {
  type: 'topupLoanApplication',
  sections: [
    {
      name: 'Låntagare',
      description: 'Lägg till uppgifter om huvudlåntagaren och eventuella medlåntagare.',
      questions: ['Borrowers'],
    },
    {
      name: 'Ansökt lånebelopp',
      description: 'Ange lånebelopp, prioritet och övriga grunduppgifter för ansökan.',
      questions: ['LoanAmount', 'HighPriority'],
    },
    {
      name: 'Hushåll',
      description: 'Lägg till personer i hushållet.',
      questions: ['HouseholdChildren'],
    },
    {
      name: 'Tillgångar & skulder',
      description: 'Lägg till hushållets fordon, tillgångar, lån och andra bostäder.',
      questions: ['HouseholdCars', 'CapitalAssets', 'OtherLoans', 'OtherProperties'],
    },
    {
      name: 'Syfte med höjning av lån',
      description: 'Välj vad låneutökningen eller flytten ska användas till.',
      questions: ['TopupPurpose', 'TopupPurposeOther'],
    },
    {
      name: 'Kommentar',
      description: 'Lägg till intern information som är relevant för handläggningen.',
      questions: ['Comment'],
    },
  ],
}

export default form
